// extracted by mini-css-extract-plugin
export default {"wrapperSkeletLoader":"SkeletLoader_wrapperSkeletLoader__pxSly","loader":"SkeletLoader_loader__1yRy+","shine":"SkeletLoader_shine__t03ca"};